import styles from "../../assets/styles/Wallet/Wallet.module.scss";
import React, { useMemo, useState } from "react";
import {
  AppPage,
  BusinessInsightComponent as BIC,
  PageLoader,
  MimaTable,
} from "../../components";
import { amountFormatter } from "../../utils/utils";
import constant from "../../utils/constant";

const Wallet = ({
  loading,
  wallets,
  walletBalance,
  setCurrencyCode,
  currencyCode,
  goToSpecificWallet,
  isLoading,
  data,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
}) => {
  const [curr, setCurr] = useState("NGN");

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.value || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business?.tradingName;
        return <span>{businessName}</span>;
      },
    },
    {
      Header: "Current Balance",
      accessor: "balance",
      Cell: ({ cell }) => {
        const balance = cell.value;
        return <span>{amountFormatter(currencyCode).format(balance)}</span>;
      },
    },
    {
      Header: "Previous Balance",
      accessor: "previousBalance",
      Cell: ({ cell }) => {
        const previousBalance = cell.value;
        return (
          <span>{amountFormatter(currencyCode).format(previousBalance)}</span>
        );
      },
    },
    {
      Header: "Stamp Duty Charge",
      accessor: "chargeStampDuty",
      Cell: ({ cell }) => {
        const stampDuty = cell.value;
        return <span>{stampDuty ? "YES" : "NO"}</span>;
      },
    },
    {
      Header: "Transfer Limits",
      Cell: ({ cell }) => {
        const dailyTransferLimit = cell.row.original?.dailyTransferLimit;
        const weeklyTransferLimit = cell.row.original?.weeklyTransferLimit;
        const monthlyTransferLimit = cell.row.original?.monthlyTransferLimit;
        return (
          <span>{`${amountFormatter(currencyCode).format(dailyTransferLimit)} Daily ${amountFormatter(currencyCode).format(weeklyTransferLimit)} Weekly ${amountFormatter(currencyCode).format(monthlyTransferLimit)} Monthly`}</span>
        );
      },
    },
    {
      Header: "Max USD Per Spend",
      accessor: "maxUSDPerSpend",
      Cell: ({ cell }) => {
        const maxUSDPerSpend = cell.row.original?.maxUSDPerSpend;
        const formatedMaxUSDPerSpend =
          amountFormatter(currencyCode).format(maxUSDPerSpend);
        return <span>{formatedMaxUSDPerSpend}</span>;
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              goToSpecificWallet(item?.business);
            }}
          >
            View More
          </span>
        );
      },
    },
  ];

  return (
    <AppPage pageTitle="Wallet">
      {loading ? (
        <PageLoader title="While we set things up for you" />
      ) : (
        <>
          <div className={styles.cards}>
            {walletBalance.map((item) => (
              <BIC
                info={
                  item.currencyCode.currencyCode === "NGN"
                    ? "Total sum of money available in Naira Wallet"
                    : item.currencyCode.currencyCode === "USD"
                      ? "Total sum of money available in Dollar Wallet"
                      : item.currencyCode.currencyCode === "GBP"
                        ? "Total sum of money available in Pounds Wallet"
                        : "Total sum of money available in Euro Wallet"
                }
                title={`Total Wallet Balance ${item.currencyCode.currencyCode}`}
                amount={amountFormatter(item.currencyCode.currencyCode).format(
                  item?.totalBalance,
                )}
                styleClass={
                  item.currencyCode.currencyCode === "NGN"
                    ? styles.cards__ngn
                    : item.currencyCode.currencyCode === "USD"
                      ? styles.cards__usd
                      : item.currencyCode.currencyCode === "GBP"
                        ? styles.cards__gbp
                        : styles.cards__eur
                }
              />
            ))}
          </div>

          <div className={styles.main_nav}>
            {walletBalance?.map((item) => (
              <div
                key={item.currencyCode.currencyCode}
                className={
                  curr === item.currencyCode.currencyCode
                    ? styles.main_nav_item_active
                    : styles.main_nav_item
                }
                onClick={() => {
                  setCurr(item.currencyCode.currencyCode);
                  setCurrencyCode(item.currencyCode.currencyCode);
                }}
              >
                {item.currencyCode.currencyCode} Wallet
              </div>
            ))}
          </div>

          <MimaTable
            tableData={tableData}
            tableColumns={tableColumns}
            searchPlaceholder="Search Subscription"
            searchVariant="wide"
            totalItems={data?.data?.totalCounts}
            onLimitChange={onLimitChange}
            isLoading={isLoading}
            isFetching={isFetching}
            limit={limit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSearchQuery={setSearchQuery}
          />
        </>
      )}
    </AppPage>
  );
};

export default Wallet;
